import { render, staticRenderFns } from "./BranchAdd.vue?vue&type=template&id=551fb003&scoped=true"
import script from "./BranchAdd.vue?vue&type=script&lang=ts"
export * from "./BranchAdd.vue?vue&type=script&lang=ts"
import style0 from "./BranchAdd.vue?vue&type=style&index=0&id=551fb003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551fb003",
  null
  
)

export default component.exports